import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import formLiveAppManagerContentNew from './formLiveAppManagerContentNew';

import formLiveAppManagerContentEdit from './formLiveAppManagerContentEdit';
import tableLiveAppManager from './tableLiveAppManager';

export default {
  title: 'Live Graphic Manager',
  attributeName: 'liveGraphicManager',
  contentFormUrl:'liveGraphicManager',
  contentFormNew:[formLiveAppManagerContentNew],
  contentFormEdit:[formLiveAppManagerContentEdit],
  // visibleWhen:{"field":"sportRoomsVisible","value":"false"},
  fields: [
    {
      attributeName: 'graphicManagersTable',
      type: FormInputTypes.POPUPTABLE,
      newButton:true,
      label: '',
      helpText: '',
      configFile: tableLiveAppManager,
    },
  ],
};
